import { render, staticRenderFns } from "./ProductCategoryDetail.vue?vue&type=template&id=18a03eec&scoped=true&"
import script from "./ProductCategoryDetail.vue?vue&type=script&lang=js&"
export * from "./ProductCategoryDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a03eec",
  null
  
)

export default component.exports